import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d2d86dd")

_pushScopeId("data-v-6d2d86dd")
const _hoisted_1 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")
  const _component_device_info_onceautop_dialog = _resolveComponent("device-info-onceautop-dialog")
  const _component_jump_page = _resolveComponent("jump-page")
  const _component_loading_animation_dialog = _resolveComponent("loading-animation-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.ProperAllTextSetting,
      onClose: _ctx.close,
      width: "250",
      "footer-type": "customize"
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode(_component_el_button, {
              class: "margin-right10px",
              type: "danger",
              onClick: _ctx.reboot
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ListInHtmlReboot), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "margin-right10px",
              type: "danger",
              onClick: _ctx.reset
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.Reset), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _ctx.remote,
              class: "margin-right10px"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextRemoteControl), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.onceAutop }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.OneTimeAutoP), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_el_button, {
              class: "margin-right10px",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              disabled: _ctx.isConfigToLong,
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          ref: "deviceSettingFormRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.DeviceDetailDetailConnectionType
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.formData.SipType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.SipType = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectType, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.DeviceDetailDetailOthers,
              error: _ctx.isConfigToLong ? _ctx.$wordList.AutoPTooLong : null,
              "inline-message": ""
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Config,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Config = $event)),
                  "auto-complete": "off",
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "error"])
          ]),
          _: 1
        }, 8, ["label-position", "model"])
      ]),
      _: 1
    }, 8, ["title", "onClose"]),
    (_ctx.showOnceDialog)
      ? (_openBlock(), _createBlock(_component_device_info_onceautop_dialog, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showOnceDialog = false)),
          params: _ctx.formData,
          identity: _ctx.identity,
          projectType: _ctx.projectType
        }, null, 8, ["params", "identity", "projectType"]))
      : _createCommentVNode("", true),
    (_ctx.isShowJumpPage)
      ? (_openBlock(), _createBlock(_component_jump_page, {
          key: 1,
          "jump-url": _ctx.jumpUrl,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowJumpPage = false))
        }, null, 8, ["jump-url"]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading_animation_dialog, {
      isShowLoadingDialog: _ctx.isShowLoadingDialog,
      title: _ctx.$wordList.ProperAllTextRemoteControl,
      content: _ctx.$wordList.InitiatingConnectionTip,
      onClose: _ctx.closeLoadingDialog
    }, null, 8, ["isShowLoadingDialog", "title", "content", "onClose"])
  ]))
})